/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IPlpSubheaderData } from './plp-subheader.data';
import { IPlpSubheaderProps } from './plp-subheader.props.autogenerated';

export interface IPlpSubheaderViewProps extends IPlpSubheaderProps<IPlpSubheaderData> {}

/**
 *
 * PlpSubheader component
 * @extends {React.PureComponent<IPlpSubheaderProps<IPlpSubheaderData>>}
 */
class PlpSubheader extends React.PureComponent<IPlpSubheaderProps<IPlpSubheaderData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default PlpSubheader;
